export default {
    globalConfig: {
        read: {
            url: `${window.baseURL}graphql`,
            query: `{
                readGlobalConfig {
                    CheckoutPaymentMethods
                    DisplayPaymentMethodSelector
                }
            }`,
        },
    },
    createGuestMember: {
        create: {
            url: `${window.baseURL}graphql`,
            query: `
                mutation createGuestMember($ResellerID: ID!) {
                    createGuestMember(ResellerID: $ResellerID) {
                        ID
                    }
                }
            `,
        },
    },

    tags: {
        getDetails: `${window.baseURL}`,
        getType: `${window.baseURL}`,
        getTypeCMS: {
            url: `${window.baseURL}graphql`,
            query: `{
              readTagTypeJSONDatas({params}) {
                edges {
                  node {
                    EncodedConfiguration
                  }
                }
              }
            }`,
        },
        getLayouts: {
            url: `${window.baseURL}graphql-product`,
            query: `query ReadTagLayouts($CodeTagFamily: String!, $TagType: String, $Compile: Boolean, $NAITVariationTypes: [String], $NAITGroupIdentifier: String, $Data: String) {
              readTagLayouts(CodeTagFamily: $CodeTagFamily, TagType: $TagType, Compile: $Compile, NAITVariationTypes: $NAITVariationTypes, NAITGroupIdentifier: $NAITGroupIdentifier, Data: $Data) {
                edges {
                  node {
                    ID
                    VariationName
                    EncodedJSONData
                    TagType
                    ImageLink
                    NAITVariationType
                    NAITGroupIdentifier
                    IncludedProducts {
                        ID
                    }
                  }
                }
              }
            }`,
        },
        validateNAITSequence: {
            url: `${window.baseURL}graphql`,
            query: `mutation validateTagSequenceMutation($VariationType: String!, $NaitNumber: String!, $Year: Int, $ParticipantCode: String, $SequenceList: [String], $StartingNumber: String, $ItemQuantity: Int, $DuplicateTag: Boolean, $BuyableDataIDs: [ID]) {
              validateTagSequenceMutation(VariationType: $VariationType, NaitNumber: $NaitNumber, Year: $Year, ParticipantCode: $ParticipantCode, SequenceList: $SequenceList, StartingNumber: $StartingNumber, ItemQuantity: $ItemQuantity, DuplicateTag: $DuplicateTag, BuyableDataIDs: $BuyableDataIDs) {
                ErrorRecords
              }
            }`,
        },
    },
    canvas: {
        url: `${window.fontsURL}/hinted-AvantGardeLT-Medium.woff`,
        svgs: [
            // `${window.baseURL}img/temp/splashbox-logo--gradient.svg`,
            // `${window.baseURL}img/temp/TEST_SVG_1.svg`,
            // `${window.baseURL}img/temp/TEST_SVG_2.svg`,
            // `${window.baseURL}img/temp/TEST_SVG_3.svg`,
            // `${window.baseURL}img/temp/TEST_SVG_4.svg`,
            // `${window.baseURL}img/temp/TEST_SVG_5.svg`
        ],
    },
    image: {
        upload: {
            url: `${window.baseURL}api/file/create`,
        },
    },
    product: {
        categories: {
            url: `${window.baseURL}graphql-product`,
            query: `{
                readProductCategories {
                    edges {
                        node {
                            ID
                            Title
                            Parent {
                                ... on ProductCategory {
                                    ID
                                }
                            }
                        }
                    }
                }
            }`,
        },
        listing: {
            url: `${window.baseURL}graphql-product`,
            query: `{
                readProducts({params}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            ID
                            Title
                            FamilyTitle
                            FamilyTitleSlug
                            ProdType
                            IsNLIS
                            OfficialType
                            InternalItemID
                            ReSizedProductListingImage
                            COGS
                            IsContinuesSequenceCheckDisabled
                            DirectProductCategoriesList(limit: 1) {
                                edges {
                                    node {
                                        ProductLink
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
        },
        prices: {
            url: `${window.baseURL}graphql-product`,
            query: `{
                readBuyablePrices({params}) {
                    edges {
                        node {
                            SalePrice
                            RRP
                            BuyableID
                            ProductFamilyRef
                            CurrencyFormat
                            CurrencyDisplayCode
                        }
                    }
                }
            }`,
        },
        variations: {
            url: `${window.baseURL}graphql-product`,
            query: `{
                readProducts(Filters: {FamilyTitleSlug: "{familyTitleSlug}", Sort: "SortByCode__ASC"}) {
                    edges {
                        node {
                            ID
                            Title
                            ProdType
                            InternalItemID
                            ReSizedProductDetailImage
                            ReSizedProductListingImage
                            ExtraText1
                            ExtraText2
                            ExtraText3
                            ExtraText4
                            TagColour
                            FontColourCode
                            SellByPackageOnly
                            MinOrderQuantity
                            WholesaleMinOrderQuantity
                            ItemWidth
                            ItemHeight
                            ItemDepth
                            ItemWeight
                            IsContinuesSequenceCheckDisabled
                            RelatedProducts {
                                edges {
                                    node {
                                        ID
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
        },
        tagWizardVariations: {
            url: `${window.baseURL}graphql-product`,
            query: `{
                readProducts({params}) {
                    edges {
                        node {
                            ID
                            Title
                            FamilyTitle
                            ProdType
                            InternalItemID
                            ReSizedProductDetailImage
                            ReSizedProductListingImage
                            ExtraText1
                            ExtraText2
                            ExtraText3
                            ExtraText4
                            ItemWidth
                            ItemHeight
                            ItemDepth
                            ItemWeight
                            Content
                            TagColour
                            ColourCode
                            FontColourCode
                            OfficialColourName
                            FoilStamping
                            SellByPackageOnly
                            MinOrderQuantity
                            WholesaleMinOrderQuantity
                            IsNLIS
                            TagShape
                            CustomTag
                            BlankTag
                            Brand
                            DiseaseCode
                            PostBreederLetter
                            MarkingLines
                            FoilMarkingLines
                            IsContinuesSequenceCheckDisabled
                            Images {
                                edges {
                                    node {
                                        ReSizedProductDetailImage
                                        ReSizedProductListingImage
                                    }
                                }
                            }
                            RelatedTags {
                                edges {
                                    node {
                                        ID
                                    }
                                }
                            }
                            RelatedProducts {
                                edges {
                                    node {
                                        ID
                                    }
                                }
                            }
                            ButtonRequired
                            CodeTagFamily
                            MMT1
                            MMT2
                            MMT3
                            MMT4
                            MMT5
                            MMTF1
                            MMTF2
                            MMTF3
                            MMTF4
                            MMTF5
                            MaleButtons {
                                edges {
                                    node {
                                        ID
                                    }
                                }
                            }
                            AllowVic
                            BuyableContinueSequence
                            OfficialType
                            Replacement
                            IsCattle
                            IsDeer
                        }
                    }
                }
            }`,
        },
        listingByIDs: {
            url: `${window.baseURL}graphql-product`,
            query: `{
                readProducts(Filters: {IDs: {ids}}) {
                    edges {
                        node {
                            ID
                            Title
                            ProdType
                            InternalItemID
                            ReSizedProductListingImage
                            IsContinuesSequenceCheckDisabled
                            Images {
                                edges {
                                    node {
                                        ReSizedProductDetailImage
                                        ReSizedProductListingImage
                                    }
                                }
                            }
                            CodeTagFamily
                            DirectProductCategoriesList(limit: 1) {
                                edges {
                                    node {
                                        ProductLink
                                    }
                                }
                            }
                            IsNLIS
                            OfficialType
                        }
                    }
                }
            }`,
        },
    },
    productConfigurator: {
        listing: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readProductsWarehouseStocks({params}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            ID
                            StockOnHandUnits
                            StockOnHandPackages
                            Sort
                            WarehouseCode
                            ProductsWarehouseID
                            BuyableID
                        }
                    }
                }
            }`,
        },
        buyPrices: {
            url: `${window.baseURL}graphql`,
            query: `{
                readOwnedProductPrices({params}) {
                    SalePriceID
                    SupplyPrice
                    RRP
                    SalePrice
                    BuyableID
                    RetailPrice
                    COGS
                    CurrencyFormat
                    CurrencyDisplayCode
                }
            }`,
        },
        globalPrices: {
            url: `${window.baseURL}graphql`,
            query: `{
                readGlobalOwnedProductPrices({params}) {
                    BuyableID
                    RetailPriceID
                    WholesalePriceID
                    ResellerPriceID
                    CogsID
                    RetailPrice
                    WholesalePrice
                    ResellerPrice
                    Cogs
                    CurrencyFormat
                    CurrencyDisplayCode
                }
            }`,
        },
        regionalPrices: {
            url: `${window.baseURL}graphql`,
            query: `{
                readRegionalOwnedProductPrices({params}) {
                    BuyableID
                    CogsGlobal
                    WholesaleGlobalPrice
                    WholesaleRegionalPrice
                    WholesaleRegionalPriceID
                    RetailDefaultPrice
                    WholesaleDefaultPrice
                    ResellerDefaultPrice
                    RetailPrice
                    RetailPriceID
                    WholesalePrice
                    WholesalePriceID
                    ResellerPrice
                    ResellerPriceID
                    GlobalCurrencyFormat
                    GlobalCurrencyDisplayCode
                    LocalCurrencyFormat
                    LocalCurrencyDisplayCode
                }
            }`,
        },
        wholesalerPrices: {
            url: `${window.baseURL}graphql`,
            query: `{
                readWholesalerOwnedProductPrices({params}) {
                    BuyableID
                    RetailDefaultPrice
                    WholesaleDefaultPrice
                    ResellerDefaultPrice
                    ResellerBuyPrice
                    ResellerBuyPriceID
                    RetailBuyPrice
                    RetailBuyPriceID
                    GlobalCurrencyFormat
                    GlobalCurrencyDisplayCode
                    LocalCurrencyFormat
                    LocalCurrencyDisplayCode
                }
            }`,
        },
        parentResellerPrices: {
            url: `${window.baseURL}graphql`,
            query: `{
                readOwnedProductPrices({params}) {
                    BuyableID
                    SupplyPrice
                    ResellerPrice
                    ResellerPriceID
                    RetailPrice
                    SalePrice
                    SalePriceID
                    CurrencyFormat
                    CurrencyDisplayCode
                }
            }`,
        },
        save: {
            url: `${window.baseURL}graphql-product`,
            query: ``,
        },
        updateStock: {
            url: `${window.baseURL}graphql-product`,
            query: `updateBuyableStock`,
        },
        updateSellPrice: {
            url: `${window.baseURL}graphql-product`,
            query: `updateBuyablePrice`,
        },
        updateGlobalPrice: {
            url: `${window.baseURL}graphql-product`,
            query: `updateBuyableGlobalPrice`,
        },
        updateRegionalrice: {
            url: `${window.baseURL}graphql-product`,
            query: `updateBuyableRegionalPrice`,
        },
        updateWholesalePrice: {
            url: `${window.baseURL}graphql-product`,
            query: `updateBuyableWholesalerPrice`,
        },
    },
    inStoreProduct: {
        listing: {
            // url: `http://10.1.1.120/leaderproducts.com.au-html/static/action/request-in-store-products.php`,
            url: `${window.baseURL}graphql`,
            query: `{
                readInStoreProducts({params}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            Category {
                                Title
                            }
                            ID
                            Title
                            Price
                            InternalItemID
                            Link
                            Images(limit: 1) {
                                edges {
                                    node {
                                        ID
                                        ReSizedProductListingImage
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
        },
        detail: {
            url: `${window.baseURL}graphql`,
            query: `{
                readInStoreProducts(Filters:{ID: {id}}) {
                    edges {
                        node {
                            ID
                            Title
                            Price
                            InternalItemID
                            Content
                            CategoryID
                            Images(limit: 1) {
                                edges {
                                    node {
                                        ID
                                        ReSizedProductDetailImage
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
        },
        create: {
            url: `${window.baseURL}graphql`,
            query: `createInStoreProduct`,
        },
        update: {
            url: `${window.baseURL}graphql`,
            query: `updateInStoreProduct`,
        },
        delete: {
            url: `${window.baseURL}graphql`,
            query: `deleteInStoreProduct`,
        },
        categories: {
            url: `${window.baseURL}graphql`,
            query: `{
                readInStoreProductCategories {
                    edges {
                        node {
                            ID
                            Title
                        }
                    }
                }
            }`,
        },
        createCategory: {
            url: `${window.baseURL}graphql`,
            query: `createInStoreProductCategory`,
        },
        deleteCategory: {
            url: `${window.baseURL}graphql`,
            query: `deleteInStoreProductCategory`,
        },
    },
    customers: {
        listing: {
            url: `${window.baseURL}graphql`,
            query: `{
                readMembers({params}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            ID
                            FirstName
                            Surname
                            Email
                            Created
                            BusinessName
                            TradingName
                            Hidden
                        }
                    }
                }
            }`,
        },

        validateEmail: {
            url: `${window.baseURL}graphql`,
            query: `query validateEmail($Email: String! ){
                validateEmail(Email: $Email)
         }`,
        },



        update: {
            url: `${window.baseURL}graphql`,
            query: `mutation {
                updateMemberStatus({params}) {
                    ID
                    Email
                }
            }`,
        },
        updateVisibility: {
            url: `${window.baseURL}graphql`,
            query: `mutation {
                updateMemberVisibility({params}) {
                    ID
                    Email
                }
            }`,
        },
        detail: {
            url: `${window.baseURL}graphql`,
            query: `{
                readOneMember(ID: {id}) {
                    ID
                    FirstName
                    Surname
                    BusinessName
                    TradingName
                    IsGuestUser
                    EstablishedDate
                    Phone
                    Mobile
                    Fax
                    Email
                    Website
                    ReferenceName
                    ReferenceEmail
                    ReferencePhone
                    Reference2Name
                    Reference2Email
                    Reference2Phone
                    BSB
                    BankName
                    BankAccountName
                    BankAccountNumber
                    BankSwiftCode
                    ABN
                    ACN
                    ParentID
                    StripePublishableKey
                    StripeSecretKey
                    CreateSubStoreAccessCode
                    ProvidesCardPaymentMethod
                    ProvidesAccountPaymentMethod
                    PayFastMerchantID
                    PayFastMerchantKey
                    PayFastPassphrase
                    PreferredSuppliers {
                        edges {
                            node {
                                AccountReference
                                SupplierID
                                SupplierName
                            }
                        }
                    }
                    PICNumbers {
                        edges {
                            node {
                                ID
                                Title
                                FirstName
                                LastName
                                BusinessName
                                PropertyName
                                Town
                            }
                        }
                    }
                    PICNumber {
                        ID
                    }
                    ReferralCoupons {
                        edges {
                            node {
                                ID
                                Created
                                InternalItemID
                                Title
                                Usage
                                Discount
                                Expiry
                                Commission
                                OwnedBy {
                                    ...on Wholesaler {
                                        ID
                                        BusinessName
                                    }
                                }
                            }
                        }
                    }
                    DeliveryAddresses {
                        edges {
                            node {
                                ID
                                BusinessName
                                FullAddress
                                StreetNumber
                                StreetName
                                StreetSuffix
                                Suburb
                                State
                                PostalCode
                                Country
                                Latitude
                                Longitude
                            }
                        }
                    }
                    BillingAddress {
                        ... on ElvantiAddress {
                            ID
                        }
                    }
                    DeliveryAddress {
                        ... on ElvantiAddress {
                            ID
                        }
                    }
                    BusinessAddress {
                        ... on ElvantiAddress {
                            ID
                            BusinessName
                            FullAddress
                            StreetNumber
                            StreetName
                            StreetSuffix
                            Suburb
                            State
                            PostalCode
                            Country
                        }
                    }
                    SavedCreditCards {
                        edges {
                            node {
                                ID
                                CardName
                                Title
                                Month
                                Year
                            }
                        }
                    }
                    SavedCreditCard {
                        ID
                    }
                    StripeCountryCode
                    PriceConversionRate
                    IsStripeConnectComplete
                    IsStripeConnectRequired
                    IsPayFastRequired
                    IsStripeConnectExternalAccountDue
                    IsStripeConnectOtherRequirementDue
                }
            }`,
        },
        create: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `createCoupon`,
        },
        delete: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `deleteCoupon`,
        },
    },
    coupon: {
        listing: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readAllCoupons({params}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            ID
                            InternalItemID
                            Title
                            Usage
                            Discount
                            Expiry
                            HasExpired
                            Extended
                            BuyableTitles
                        }
                    }
                }
            }`,
        },
        productListing: {
            url: `${window.baseURL}graphql-product`,
            query: `{
                readProducts({params}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            ID
                            Title
                            InternalItemID
                        }
                    }
                }
            }`,
        },
        calculateMaximumDiscount: {
            url: `${window.baseURL}graphql`,
            query: `{
                calculateCouponMaxDiscount {
                    MaximumDiscount
                }
            }`,
        },
        generateCode: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `generateCoupon`,
        },
        create: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `createCoupon`,
        },
        delete: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `deleteCoupon`,
        },
        apply: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `applyCoupon`,
        },
    },
    referralCoupon: {
        listing: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readReferralCoupons({params}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            Commission
                            ID
                            InternalItemID
                            Discount
                            Expiry
                            HasExpired
                            ReferrerName
                            Usage
                        }
                    }
                }
            }`,
        },
        detail: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readOneReferralCoupon(ID: {id}) {
                    Commission
                    ReferrerName
                    ID
                    InternalItemID
                    Title
                    Usage
                    Discount
                    Expiry
                    HasExpired
                }
            }`,
        },
        calculateMaximumDiscount: {
            url: `${window.baseURL}graphql`,
            query: `{
                calculateCouponMaxDiscount {
                    MaximumDiscount
                }
            }`,
        },
        generateCode: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `generateReferralCoupon`,
        },
        create: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `createReferralCoupon`,
        },
        update: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `updateReferralCoupon`,
        },
        delete: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `deleteReferralCoupon`,
        },
    },
    picNumber: {
        listing: {
            url: `${window.baseURL}graphql`,
            query: `{
                readOneMember {
                    PICNumbers {
                        edges {
                            node {
                                ID
                                Title
                                FirstName
                                LastName
                                BusinessName
                                PropertyName
                                Town
                                State
                            }
                        }
                    }
                    PICNumber {
                        ID
                    }
                }
            }`,
        },
        makeDefault: {
            url: `${window.baseURL}graphql`,
            query: `updatePICNumber`,
        },
        create: {
            url: `${window.baseURL}graphql`,
            query: `createPICNumber`,
        },
        update: {
            url: `${window.baseURL}graphql`,
            query: `updatePICNumber`,
        },
        delete: {
            url: `${window.baseURL}graphql`,
            query: `deletePICNumber`,
        },
        lastSequenceNumber: {
            url: `${window.baseURL}graphql`,
            query: `{
                readLastSequenceNumber {
                    Sequence
                }
            }`,
        },
        lastSequenceNumberWithPrefix: {
            url: `${window.baseURL}graphql`,
            query: `{
                readLastSequenceNumber(Prefix: {Prefix}, PIC: {PICNumber}, ProductType: {PostBreederLetter}, ContinueSequence: {ContinueSequence} , BuyableID: {BuyableID}) {
                    Sequence
                }
            }`,
        },
    },
    invoice: {
        paidListing: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readInvoices(Filters:{}) {
                    pageInfo {
                        totalCount
                        hasNextPage
                        hasPreviousPage
                    }
                    edges {
                        node {
                            ID
                            InternalItemID
                            OrderID
                            Order {
                                InternalItemID
                                Placed
                                Total
                            }
                            PaidDate
                            Status
                            Paid
                            TotalDue
                            CurrencyFormat
                            CurrencyDisplayCode
                        }
                    }
                }
            }`,
        },
        unpaidListing: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readInvoices(Filters:{}) {
                    edges {
                        node {
                            ID
                            Status
                            Pending
                            Paid
                            TotalDue
                            DueDate
                            OrderID
                            InternalItemID
                            Order {
                              Placed
                              InternalItemID
                            }
                            CurrencyFormat
                            CurrencyDisplayCode
                        }
                    }
                }
            }`,
        },
        reciprocalListing: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readReciprocalInvoices(Filters:{}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            ID
                            OrderID
                            InternalItemID
                            Order {
                                Placed
                                InternalItemID
                            }
                            TotalDue
                            DueDate
                            PaidDate
                            Status
                            Paid
                            ResellerBusinessName
                            CurrencyFormat
                            CurrencyDisplayCode
                        }
                    }
                }
            }`,
        },
        overdue: {
            url: `${window.baseURL}account/readOverDueTotal/`,
        },
        pay: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `payForInvoice`,
        },
        updateStatus: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {
              updateInvoiceStatus(ID: {ID}, Status: "{Status}"){
                ID
                Status
                OrderID
              }
            }`,
        },
    },
    order: {
        listing: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readCartOrders({params}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            ID
                            Placed
                            Status
                            ShippingStatus
                            CurrencyDisplayCode
                            CurrencyFormat
                            Total
                            PaymentMethod
                            InternalItemID
                            FirstName
                            Surname
                            BusinessName
                            ResellerName
                            PaymentMethod
                            HasTags
                            ContainItemTypes
                            PostmenLabelUrl
                            BoxPackerParcelCount
                            PostmenTrackingInfo
                            ShippingMethod

                            OrderInvoice {
                                ... on Invoice {
                                    ID
                                    Status
                                }
                            }
                            PlacedOnBehalfBy {
                                ...on SilverStripeMember {
                                    ID
                                    BusinessName
                                    FirstName
                                    Surname
                                }
                                ... on Wholesaler {
                                    ID
                                  }
                                  ... on Reseller {
                                    ID
                                  }
                            }
                            ParentMember {
                                ...on SilverStripeMember {
                                    ID
                                    BusinessName
                                    FirstName
                                    Surname
                                }
                            }
                        }
                    }
                }
            }`,
        },
        detail: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readCartOrders({params}) {
                    edges {
                        node {
                            ID
                            Placed
                            Status
                            ShippingStatus
                            ShippingTotal
                            DiscountTotal
                            TaxTotal
                            Total
                            PaymentMethod
                            InternalItemID
                            BusinessName
                            FirstName
                            Surname

                            BillingAddress {
                                FullAddress
                            }
                            ShippingAddress {
                                FullAddress
                            }
                            PlacedOnBehalfBy {
                                ...on SilverStripeMember {
                                    ID
                                    BusinessName
                                    FirstName
                                    Surname
                                }
                                ... on Wholesaler {
                                    ID
                                  }
                                  ... on Reseller {
                                    ID
                                  }
                            }
                            ParentMember {
                                ...on SilverStripeMember {
                                    ID
                                    BusinessName
                                    FirstName
                                    Surname
                                }
                            }
                            Items {
                                edges {
                                    node {
                                        Title
                                        InternalItemID
                                        ExternalItemID
                                        TotalUnitItems
                                        UnitPrice
                                        TotalPrice
                                        ID
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
        },
        pay: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `payForOrder`,
        },
        update: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `updateOrder`,
        },
        approval: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {mutationParams} {
                approveOrder({params}) {
                    Status
                    Approved
                    OperatorCode
                    ResellerPurchaseOrder
                    NaitSequenceErrors
                }
            }`,
        },
        placeBackOrder: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation placeBackOrder($OrderID: ID! , $Buyables: [CartItemInput], $FreightAmount: Float!, $TrackingNo: String!  ){
                placeBackOrder(OrderID: $OrderID , Buyables: $Buyables, FreightAmount: $FreightAmount, TrackingNo: $TrackingNo){
                    ID
                }
         }`,
        },
        updateOrderFreight: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `updateOrderFreight`,
        },
        reject: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {mutationParams} {
                voidOrder({params}) {
                    Status
                    Voided
                    OperatorCode
                    ResellerPurchaseOrder
                }
            }`,
        },
        contactCustomer: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {mutationParams} {
                buyerContactedOrder({params}) {
                    Status
                    BuyerContacted
                    OperatorCode
                    ResellerPurchaseOrder
                }
            }`,
        },
        editPlacedOrder: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation editPlacedOrder($ID: ID!) {
              editPlacedOrder(ID: $ID) {
                ID
                Status
              }
            }`,
        },
        reOrderSettings: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `query readOneCartOrder($ID: Int!) {
              readOneCartOrder(ID: $ID) {
                 ID
                Status
                DiscountTotal
                ShippingTotal
                TaxTotal
                SubTotal
                Total
                Currency
                PlacedOnBehalfBy {
                    ... on Wholesaler {
                      ID
                    }
                    ... on Reseller {
                      ID
                    }
                  }
                AppliedDiscountCoupon {
                  ... on Coupon {
                    Title
                    InternalItemID
                  }
                  ... on ReferralCoupon {
                    Title
                    InternalItemID
                  }
                }
                TaxDataItems {
                  edges {
                    node {
                      Title
                      CalculatedTax
                    }
                  }
                }
                TaxSummary
                HasTaxInclusive
                ExtraAttribute1
                PaymentMethod
                Notes
                IsTotalGreaterThanSourceOrder
                SourceOrder {
                  ID
                  Total
                }
                Member{
                    ... on SilverStripeMember {
                        ID
                        Title
                    }
                    ... on Wholesaler {
                        ID
                      }
                      ... on Reseller {
                        ID
                      }
                      ... on Customer {
                        ID
                      }
                  }
                Items {
                  edges {
                    node {
                      Title
                      DisplayImage
                      ItemType
                      IsCustomTag
                      InternalItemID
                      ExternalItemID
                      ItemsInPackage
                      TotalUnitItems
                      UnitPrice
                      TotalPriceWithoutTax
                      TotalPrice
                      ID
                      Created
                      TagWizardData
                      TagEditorData
                      TagSummaryData
                      TagPreviewImageBack
                      TagPreviewImageFront
                      SVGPreviewFront
                      SVGPreviewBack
                      MarkingCodeBack
                      MarkingCodeFront
                      PrintOption
                      ParentItem {
                        ... on CartOrderItem {
                          ID
                        }
                      }
                      BuyableLink
                      Buyable {
                        ... on Product {
                            ID
                          SellByPackageOnly
                          MinOrderQuantity
                          WholesaleMinOrderQuantity

                          OfficialType
                        IsNLIS
                        }
                      }
                      Notes
                    }
                  }
                }
              }
            }`,
        },
        viewOrderSettings: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `query readOneCartOrder($ID: Int!) {
              readOneCartOrder(ID: $ID) {
                ID
                LastEdited
                Approved
                Voided
                BuyerContacted
                OperatorCode
                ResellerPurchaseOrder
                CanCurrentUserEditOrder
                CanCurrentUserDoActionsOnOrder
                PaymentMethod
                Items {
                    edges {
                      node {
                        Title
                        DisplayImage
                        ItemType
                        IsCustomTag
                        InternalItemID
                        ExternalItemID
                        ItemsInPackage
                        TotalUnitItems
                        UnitPrice
                        TotalPriceWithoutTax
                        TotalPrice
                        ID
                        Created
                        TagWizardData
                        TagEditorData
                        TagSummaryData
                        TagPreviewImageBack
                        TagPreviewImageFront
                        SVGPreviewFront
                        SVGPreviewBack
                        MarkingCodeBack
                        MarkingCodeFront
                        PrintOption
                        ParentItem {
                          ... on CartOrderItem {
                            ID
                          }
                        }
                        BuyableLink
                        Buyable {
                          ... on Product {
                              ID
                            SellByPackageOnly
                            MinOrderQuantity
                            WholesaleMinOrderQuantity

                            OfficialType
                          IsNLIS
                          }
                        }
                        Notes
                      }
                    }
                  }

                Member{
                    ... on SilverStripeMember {
                      ID
                      Title
                    }
                    ... on Wholesaler {
                        ID
                      }
                      ... on Reseller {
                        ID
                      }
                      ... on Customer {
                        ID
                      }
                  }
              }
            }`,
        },
    },
    receipt: {
        listing: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readCartOrders({params}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            ID
                            Placed
                            Paid
                            Status
                            ShippingStatus
                            Total
                            PlacedOnBehalfBy {
                                ... on Wholesaler {
                                  ID
                                }
                                ... on Reseller {
                                  ID
                                }
                              }
                        }
                    }
                }
            }`,
        },
    },
    checkout: {
        processPayment: {
            url: `${window.baseURL}checkout/process`,
        },
        update: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `updateCart`,
        },
        updateShipping: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `updateCartShipping`,
        },
        removeProductAppliedCoupon: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `removeProductAppliedCoupon`,
        },
        removeAppliedCoupon: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `removeAppliedCoupon`,
        },
        updateShippingAddress: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {
                updateCartShippingAddress(ShippingAddressID: {shippingAddressID}) {
                    ID
                    ShippingAddress {
                        ID
                        FullAddress
                    }
                }
            }`,
        },
        updateDispatchLocation: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `updateCartDispatchLocation`,
        },
        updateCartPaymentMethod: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {
                updateCartPaymentMethod(PaymentMethod: "{paymentMethod}") {
                    ID
                }
            }`,
        },
        deliveryOptions: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readCombinedShippingMethods {
                    edges {
                        node {
                            ID
                            Title
                            ShipperInternalID
                            ShipperExternalID
                            ShipperServiceType
                            DisplayTotal
                            DiscountedTotal
                            Discount
                        }
                    }
                }
            }`,
        },
    },
    cart: {
        listing: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readOneCart {
                    ID
                    Status
                    DiscountTotal
                    ShippingTotal
                    TaxTotal
                    SubTotal
                    Total
                    Currency
                    AppliedDiscountCoupon {
                        ...on Coupon {
                            Title
                            InternalItemID
                        }
                        ...on ReferralCoupon {
                            Title
                            InternalItemID
                        }
                    }
                    TaxDataItems {
                        edges {
                            node {
                                Title
                                CalculatedTax
                            }
                        }
                    }
                    TaxSummary
                    HasTaxInclusive
                    ExtraAttribute1
                    PaymentMethod
                    Notes
                    IsTotalGreaterThanSourceOrder
                    PlacedOnBehalfBy {
                        ...on SilverStripeMember {
                            ID
                            BusinessName
                            FirstName
                            Surname
                        }
                        ... on Wholesaler {
                            ID
                          }
                          ... on Reseller {
                            ID
                          }
                    }
                    SourceOrder {
                        ID
                        Total
                    }
                    Items {
                        edges {
                            node {
                                Title
                                TagPreviewImageFront
                                TagPreviewImageBack
                                DisplayImage
                                ItemType
                                IsCustomTag
                                InternalItemID
                                ExternalItemID
                                ItemsInPackage
                                TotalUnitItems
                                UnitPrice
                                TotalPriceWithoutTax
                                TotalPrice
                                ID
                                Created
                                ParentItem {
                                    ... on CartOrderItem {
                                        ID
                                    }
                                }
                                BuyableLink
                                Buyable {
                                    ...on Product {
                                        SellByPackageOnly
                                        MinOrderQuantity
                                        WholesaleMinOrderQuantity
                                    }
                                }
                                Notes
                            }
                        }
                    }
                    IsBackOrder
                }
            }`,
        },
        detail: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readOneCart {
                    ID
                    Status
                    TradingName
                    BusinessName
                    Phone
                    FirstName
                    Surname
                    Email
                    Notes
                    ExtraAttribute1
                    PaymentMethod
                    Notes
                    IsTotalGreaterThanSourceOrder
                    IsPaymentCaptureFailed
                    PlacedOnBehalfBy {
                        ...on SilverStripeMember {
                            ID
                            BusinessName
                            FirstName
                            Surname
                        }
                        ... on Wholesaler {
                            ID
                          }
                          ... on Reseller {
                            ID
                          }
                    }
                    SourceOrder {
                        ID
                        PaymentMethod
                        Total
                    }
                    Shipping {
                        ... on ShippingMethod{
                            ID
                        }
                    }
                    ShippingAddress {
                        ... on ElvantiOrderAddress {
                            ID
                        }
                    }
                    BillingAddress {
                        ... on ElvantiOrderAddress {
                            ID
                        }
                    }
                    AppliedDiscountCoupon {
                        ... on Coupon {
                            ID
                            InternalItemID
                        }
                    }
                    IsBackOrder
                    AppliedDiscountTotal
                    ProductDiscountItems{
                        edges{
                            node{
                                ID
                                InternalItemID
                                Amount
                                Item{
                                    ... on CartOrderItem{
                                        InternalItemID
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
        },
        add: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {
                addCartOrderItem({params}) {
                    ID
                }
            }`,
        },
        addCustomTag: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation addCartOrderItemCustomTag($BuyableID: ID!, $ProductType: String, $TotalUnitItems: Int, $TotalPackageItems: Int, $Notes: String, $RelatedBuyables: String, $SequenceStartingNumber: String, $ContinueSequence: Boolean, $SequencePrefix: String, $PICVerified: Boolean, $PICNumber: String, $TagWizardData: String, $TagEditorData: String, $TagSummaryData: String, $IsCustomTag: Boolean, $TagType: Int, $SVGPreviewFront: String, $SVGPreviewBack: String, $MarkingCodeFront: String, $MarkingCodeBack: String, $PrintOption: Int, $DuplicateTag: Boolean, $ParticipantCode: String, $TagYear: String, $VariationType: String, $SequenceList: String) {
                addCartOrderItemCustomTag(BuyableID: $BuyableID, ProductType: $ProductType, TotalUnitItems: $TotalUnitItems, TotalPackageItems: $TotalPackageItems, Notes: $Notes, RelatedBuyables: $RelatedBuyables, SequenceStartingNumber: $SequenceStartingNumber, ContinueSequence: $ContinueSequence, SequencePrefix: $SequencePrefix, PICVerified: $PICVerified, PICNumber: $PICNumber, TagWizardData: $TagWizardData, TagEditorData: $TagEditorData, TagSummaryData: $TagSummaryData, IsCustomTag: $IsCustomTag, TagType: $TagType, SVGPreviewFront: $SVGPreviewFront, SVGPreviewBack: $SVGPreviewBack, MarkingCodeFront: $MarkingCodeFront, MarkingCodeBack: $MarkingCodeBack, PrintOption: $PrintOption, DuplicateTag: $DuplicateTag, ParticipantCode: $ParticipantCode, TagYear: $TagYear, VariationType: $VariationType, SequenceList: $SequenceList) {
                    ID
                }
            }`,
        },
        addReOrderCustomTag: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation addCartOrderItemCustomTag($Buyables: [CartItemInput]!) {
                addCartOrderItemCustomTag(Buyables: $Buyables) {
                    ID
                }
            }`,
        },
        updateCustomTag: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation updateCartOrderItemCustomTag($ID: ID!, $BuyableID: ID, $TotalUnitItems: Int, $TotalPackageItems: Int, $Notes: String, $RelatedBuyables: String, $SequenceStartingNumber: String, $ContinueSequence: Boolean, $SequencePrefix: String, $PICVerified: Boolean, $PICNumber: String, $TagWizardData: String, $TagEditorData: String, $TagSummaryData: String, $IsCustomTag: Boolean, $TagType: Int, $SVGPreviewFront: String, $SVGPreviewBack: String, $MarkingCodeFront: String, $MarkingCodeBack: String, $PrintOption: Int, $DuplicateTag: Boolean, $ParticipantCode: String, $TagYear: String, $VariationType: String, $SequenceList: String) {
                updateCartOrderItemCustomTag(ID: $ID, BuyableID: $BuyableID, TotalUnitItems: $TotalUnitItems, TotalPackageItems: $TotalPackageItems, Notes: $Notes, RelatedBuyables: $RelatedBuyables, SequenceStartingNumber: $SequenceStartingNumber, ContinueSequence: $ContinueSequence, SequencePrefix: $SequencePrefix, PICVerified: $PICVerified, PICNumber: $PICNumber, TagWizardData: $TagWizardData, TagEditorData: $TagEditorData, TagSummaryData: $TagSummaryData, IsCustomTag: $IsCustomTag, TagType: $TagType, SVGPreviewFront: $SVGPreviewFront, SVGPreviewBack: $SVGPreviewBack, MarkingCodeFront: $MarkingCodeFront, MarkingCodeBack: $MarkingCodeBack, PrintOption: $PrintOption, DuplicateTag: $DuplicateTag, ParticipantCode: $ParticipantCode, TagYear: $TagYear, VariationType: $VariationType, SequenceList: $SequenceList) {
                    ID
                }
            }`,
        },
        update: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {mutationParams} {
                updateCartOrderItem({params}) {
                    ID
                    Status
                    DiscountTotal
                    ShippingTotal
                    TaxTotal
                    SubTotal
                    Total
                    Currency
                    ExtraAttribute1
                    PaymentMethod
                    Notes
                    IsTotalGreaterThanSourceOrder
                    SourceOrder {
                        ID
                        Total
                    }
                    Items {
                        edges {
                            node {
                                Title
                                TagPreviewImageFront
                                TagPreviewImageBack
                                DisplayImage
                                ItemType
                                IsCustomTag
                                InternalItemID
                                ExternalItemID
                                ItemsInPackage
                                TotalUnitItems
                                UnitPrice
                                TotalPriceWithoutTax
                                UnitTax
                                Packagetax
                                TotalPrice
                                ID
                                Created
                                ParentItem {
                                    ... on CartOrderItem {
                                        ID
                                    }
                                }
                                BuyableLink
                                Buyable {
                                    ...on Product {
                                        SellByPackageOnly
                                        MinOrderQuantity
                                        WholesaleMinOrderQuantity
                                    }
                                }
                                Notes
                            }
                        }
                    }
                }
            }`,
        },
        remove: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `deleteCartOrderItem`,
        },
        readTag: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readOneCartOrderItem({params}) {
                    ID
                    TagWizardData
                    TagEditorData
                }
            }`,
        },
    },
    creditCard: {
        listing: {
            url: `${window.baseURL}graphql`,
            query: `{
                readOneMember {
                    SavedCreditCards {
                        edges {
                            node {
                                ID
                                CardName
                                Title
                                Month
                                Year
                            }
                        }
                    }
                    SavedCreditCard {
                        ID
                    }
                }
            }`,
        },
        bankDetails: {
            url: `${window.baseURL}graphql`,
            query: `{
                readBankDetails(InvoiceID: {InvoiceID}) {
                    ID
                    BusinessName
                    TradingName
                    BSB
                    BankName
                    BankAccountName
                    BankAccountNumber
                    BankSwiftCode
                }
            }`,
        },
        defaultCreditCardID: {
            url: `${window.baseURL}graphql`,
            query: `{
                readOneMember {
                    SavedCreditCard {
                        ID
                    }
                }
            }`,
        },
        makeDefault: {
            url: `${window.baseURL}graphql`,
            query: `updateCreditCard`,
        },
        create: {
            url: `${window.baseURL}graphql`,
            query: `createCreditCard`,
        },
        delete: {
            url: `${window.baseURL}graphql`,
            query: `deleteCreditCard`,
        },
        createAddress: {
            url: `${window.baseURL}graphql-core`,
            query: `createAddress`,
        },
    },
    user: {
        updateDetails: {
            url: `${window.baseURL}graphql`,
            query: `updateMemberInfo`,
        },
        updateStripeDetails: {
            url: `${window.baseURL}graphql`,
            query: `validateStripeConnectAccount`,
        },
        updatePayFastDetails: {
            url: `${window.baseURL}graphql`,
            query: `validatePayFastAccount`,
        },
        updateSelectedSupplierInfo: {
            url: `${window.baseURL}graphql`,
            query: `updateMemberSupplierInfo`,
        },
        preferredSupplier: {
            url: `${window.baseURL}graphql`,
            query: `{
                readOneMember {
                    PreferredSuppliers {
                        edges {
                            node {
                                AccountReference
                                SupplierID
                                SupplierName
                            }
                        }
                    }
                }
            }`,
        },
        deletePreferredSupplier: {
            url: `${window.baseURL}graphql`,
            query: `deletePreferredSupplier`,
        },
        filteredSuppliers: {
            url: `${window.baseURL}graphql`,
            query: `{
                readMemberFilteredSuppliers(AddressID: {AddressID}) {
                    ID
                    BusinessName
                    FirstName
                    Surname
                    Assigned
                    BusinessAddress {
                        FullAddress
                    }
                }
            }`,
        },
        defaultDeliveryAddressID: {
            url: `${window.baseURL}graphql`,
            query: `{
                readOneMember {
                    DeliveryAddress {
                        ... on ElvantiAddress {
                            ID
                        }
                    }
                }
            }`,
        },
        defaultBillingAddressID: {
            url: `${window.baseURL}graphql`,
            query: `{
                readOneMember {
                    BillingAddress {
                        ... on ElvantiAddress {
                            ID
                        }
                    }
                }
            }`,
        },
        basicInfo: {

            url: `${window.baseURL}graphql`,
            query: `query readOneMember($limit: Int , $search:String , $PurchasingUser:Boolean){
                readOneMember (PurchasingUser:$PurchasingUser){
                    ID
                    EXOAccountID
                    AccessCodeToCopyURL
                    IsGuestUser
                    PriceConversionRate
                    ParentID
                    IsStripeConnectComplete
                    PayFastMerchantID
                    PayFastMerchantKey
                    PayFastPassphrase
                    IsPayFastRequired
                    PreferredSuppliers {
                        edges {
                            node {
                                AccountReference
                                SupplierID
                                SupplierName
                            }
                        }
                    }
                    DispatchLocations (limit: $limit, search: $search){
                        edges{
                        node{
                          Address{
                            ... on ElvantiAddress{
                              BusinessName
                              FullAddress
                              StreetNumber
                              StreetName
                              StreetSuffix
                              Suburb
                              State
                              PostalCode
                              Country
                            }
                          }
                          ID
                          IsDefault
                        }
                      }
                    }
                    DeliveryAddresses (limit: $limit, search: $search) {
                        edges {
                            node {
                                ID
                                BusinessName
                                Phone
                                FullAddress
                                StreetNumber
                                StreetName
                                StreetSuffix
                                Suburb
                                State
                                PostalCode
                                Country
                                Latitude
                                Longitude
                            }
                        }
                    }
                    BillingAddress {
                        ... on ElvantiAddress {
                            ID
                        }
                    }
                    DeliveryAddress {
                        ... on ElvantiAddress {
                            ID
                        }
                    }
                    BusinessAddress {
                        ... on ElvantiAddress {
                            ID
                            BusinessName
                            FullAddress
                            StreetNumber
                            StreetName
                            StreetSuffix
                            Suburb
                            State
                            PostalCode
                            Country
                        }
                    }
                }
            }`,
        },
        detailedInfo: {
            url: `${window.baseURL}graphql`,
            query: `query readOneMember($limit: Int , $search:String , $PurchasingUser:Boolean){
                readOneMember (PurchasingUser:$PurchasingUser){
                    ID
                    EXOAccountID
                    IsGuestUser
                    AccessCodeToCopyURL
                    FirstName
                    Surname
                    BusinessName
                    TradingName
                    EstablishedDate
                    Phone
                    Mobile
                    Fax
                    Email
                    Website
                    ReferenceName
                    ReferenceEmail
                    ReferencePhone
                    Reference2Name
                    Reference2Email
                    Reference2Phone
                    BSB
                    BankName
                    BankAccountName
                    BankAccountNumber
                    BankSwiftCode
                    ABN
                    ACN
                    ParentID
                    StripePublishableKey
                    StripeSecretKey
                    CreateSubStoreAccessCode
                    ProvidesCardPaymentMethod
                    ProvidesAccountPaymentMethod
                    PayFastMerchantID
                    PayFastMerchantKey
                    PayFastPassphrase
                    IsPayFastRequired
                    PreferredSuppliers {
                        edges {
                            node {
                                AccountReference
                                SupplierID
                                SupplierName
                            }
                        }
                    }
                    PICNumbers {
                        edges {
                            node {
                                ID
                                Title
                                FirstName
                                LastName
                                BusinessName
                                PropertyName
                                Town
                            }
                        }
                    }
                    PICNumber {
                        ID
                    }
                    ReferralCoupons {
                        edges {
                            node {
                                ID
                                Created
                                InternalItemID
                                Title
                                Usage
                                Discount
                                Expiry
                                Commission
                                OwnedBy {
                                    ...on Wholesaler {
                                        ID
                                        BusinessName
                                    }
                                }
                            }
                        }
                    }
                    DispatchLocations (limit: $limit, search: $search){
                        edges{
                        node{
                          Address{
                            ... on ElvantiAddress{
                              BusinessName
                              FullAddress
                              StreetNumber
                              StreetName
                              StreetSuffix
                              Suburb
                              State
                              PostalCode
                              Country
                            }
                          }
                          ID
                          IsDefault
                        }
                      }
                    }
                    DeliveryAddresses(limit: $limit, search: $search) {
                        edges {
                            node {
                                ID
                                BusinessName
                                Phone
                                FullAddress
                                StreetNumber
                                StreetName
                                StreetSuffix
                                Suburb
                                State
                                PostalCode
                                Country
                                Latitude
                                Longitude
                            }
                        }
                    }
                    BillingAddress {
                        ... on ElvantiAddress {
                            ID
                        }
                    }
                    DeliveryAddress {
                        ... on ElvantiAddress {
                            ID
                        }
                    }
                    BusinessAddress {
                        ... on ElvantiAddress {
                            ID
                            BusinessName
                            FullAddress
                            StreetNumber
                            StreetName
                            StreetSuffix
                            Suburb
                            State
                            PostalCode
                            Country
                        }
                    }
                    SavedCreditCards {
                        edges {
                            node {
                                ID
                                CardName
                                Title
                                Month
                                Year
                            }
                        }
                    }
                    SavedCreditCard {
                        ID
                    }
                    StripeCountryCode
                    PriceConversionRate
                    IsStripeConnectComplete
                    IsStripeConnectRequired
                    IsStripeConnectExternalAccountDue
                    IsStripeConnectOtherRequirementDue
                }
            }`,
        },
        stripeInfo: {
            url: `${window.baseURL}graphql`,
            query: `{
                readOneMember {
                    StripeCountryCode
                    IsStripeConnectComplete
                    IsStripeConnectRequired
                    IsStripeConnectExternalAccountDue
                    IsStripeConnectOtherRequirementDue
                    {fields}
                }
            }`,
        },
        verifyAccessCode: {
            url: `${window.baseURL}graphql`,
            query: `query VerifyAccessCode($accessCode: String!) {
                    VerifyAccessCode(accessCode: $accessCode)
                }`,
        },
        addressesAfterDeleteItem: {
            url: `${window.baseURL}graphql`,
            query: ` {
                readOneMember {
                    DeliveryAddresses  {
                        edges {
                            node {
                                ID
                                BusinessName
                                Phone
                                FullAddress
                                StreetNumber
                                StreetName
                                StreetSuffix
                                Suburb
                                State
                                PostalCode
                                Country
                                Latitude
                                Longitude
                            }
                        }
                    }
                    BillingAddress {
                        ... on ElvantiAddress {
                            ID
                        }
                    }
                    DeliveryAddress {
                        ... on ElvantiAddress {
                            ID
                        }
                    }
                    BusinessAddress {
                        ... on ElvantiAddress {
                            ID
                            BusinessName
                            FullAddress
                            StreetNumber
                            StreetName
                            StreetSuffix
                            Suburb
                            State
                            PostalCode
                            Country
                            Latitude
                            Longitude
                        }
                    }
                }
            }`,
        },
        addresses: {
            url: `${window.baseURL}graphql`,
            query: `{
                readOneMember {
                    DeliveryAddresses (limit: 5){
                        edges {
                            node {
                                ID
                                BusinessName
                                Phone
                                FullAddress
                                StreetNumber
                                StreetName
                                StreetSuffix
                                Suburb
                                State
                                PostalCode
                                Country
                                Latitude
                                Longitude
                            }
                        }
                    }
                    BillingAddress {
                        ... on ElvantiAddress {
                            ID
                        }
                    }
                    DeliveryAddress {
                        ... on ElvantiAddress {
                            ID
                        }
                    }
                    BusinessAddress {
                        ... on ElvantiAddress {
                            ID
                            BusinessName
                            FullAddress
                            StreetNumber
                            StreetName
                            StreetSuffix
                            Suburb
                            State
                            PostalCode
                            Country
                            Latitude
                            Longitude
                        }
                    }
                }
            }`,
        },
        dispatchLocations: {
            url: `${window.baseURL}graphql`,
            query: `query readOneMember($limit: Int , $search:String) {
                readOneMember {
                    DispatchLocations(limit: $limit , search:$search){
                        edges{
                        node{
                          Address{
                            ... on ElvantiAddress{
                              BusinessName
                              FullAddress
                              StreetNumber
                              StreetName
                              StreetSuffix
                              Suburb
                              State
                              PostalCode
                              Country
                            }
                          }
                          ID
                          IsDefault
                        }
                      }
                    }
                }
            }`,
        },
        createAddress: {
            url: `${window.baseURL}graphql-core`,
            query: `createAddress`,
        },
        updateAddress: {
            url: `${window.baseURL}graphql-core`,
            query: `updateAddress`,
        },
        saveDispatchLocation: {
            url: `${window.baseURL}graphql-core`,
            query: `saveDispatchLocation`,
        },
        deleteDispatchLocation: {
            url: `${window.baseURL}graphql-core`,
            query: `deleteDispatchLocation`,
        },
        makeDefaultDispatchLocation: {
            url: `${window.baseURL}graphql-core`,
            query: `makeDefaultDispatchLocation`,
        },
        updateBillingAddress: {
            url: `${window.baseURL}graphql-core`,
            query: `updateBillingAddress`,
        },
        deleteAddress: {
            url: `${window.baseURL}graphql-core`,
            query: `deleteAddress`,
        },
        saveBusinessAddress: {
            url: `${window.baseURL}graphql-core`,
            query: `updateBusinessAddress`,
        },
        postmen: {
            listing: {
                url: `${window.baseURL}graphql-enterprise`,
                query: `{
                    readMemberPostmenShippingAccounts {
                        edges {
                            node {
                                ID
                                ClassName
                                LastEdited
                                Created
                                Title
                                InternalItemID
                                ExternalItemID
                                Status
                                Sort
                                Description
                                Timezone
                                Credential_1
                                Credential_2
                                Credential_3
                                Credential_4
                                Credential_5
                                Credential_6
                                TrackingUrl
                                PriceConversionRate
                                PriceConversionEnabled
                                Manifestable
                                DangerousGoods
                            }
                        }
                    }
                }`,
            },
            format: {
                url: `${window.baseURL}api/enterprise/postmenShippersMapping`,
            },
        },
        createPostman: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `createPostmenShipperAccount`,
        },
        editPostman: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `updatePostmenShipperAccountCredentials`,
        },
        deletePostman: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `deletePostmenShipperAccount`,
        },
        cartRule: {
            listing: {
                url: `${window.baseURL}graphql`,
                query: `{
                    readCartRules {
                        edges {
                            node {
                                ID
                                Title
                                Discount
                                MinimumAmount
                                Enabled
                            }
                        }
                    }
                }`,
            },
        },
        createCartRule: {
            url: `${window.baseURL}graphql`,
            //query: `createCartRule`,
            query: `mutation createCartRule($Input: CartRuleCreateInputType!) {
                createCartRule(Input: $Input) {
                    ID
                    Title
                    Discount
                    MinimumAmount
                    Enabled
                }
            }`,
        },
        editCartRule: {
            url: `${window.baseURL}graphql`,
            query: `mutation ($Input: CartRuleUpdateInputType!) {
                updateCartRule(Input: $Input) {
                    ID
                    Title
                    Discount
                    Enabled
                    MinimumAmount
                }
            }`,
        },
        deleteCartRule: {
            url: `${window.baseURL}graphql`,
            query: `mutation ($IDs: [ID]!) {
                deleteCartRule(IDs:$IDs) {
                    ID
                  }
            }`,
        },
        referralCoupons: {
            url: `${window.baseURL}graphql`,
            query: `{
                readOneMember {
                    ReferralCoupons {
                        edges {
                            node {
                                ID
                                Created
                                InternalItemID
                                Title
                                Usage
                                Discount
                                Expiry
                                Commission
                                OwnedBy {
                                    ...on Wholesaler {
                                        ID
                                        BusinessName
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
        },
        createReferralCoupon: {
            url: `${window.baseURL}graphql`,
            query: `mutation {
                applyReferralCoupon({params}) {
                    ID
                    InternalItemID
                }
            }`,
        },
        stripeConnectExtraFields: {
            url: `${window.baseURL}graphql`,
            query: `{
                readStripeConnectExtraFields {
                    Data
                }
            }`,
        },
        payFastConnectExtraFields: {
            url: `${window.baseURL}graphql`,
            query: `{
                readPayFastExtraFields {
                    Data
                }
            }`,
        },
    },
    registration: {
        supplierList: {
            url: `${window.baseURL}graphql`,
            query: `{
                readMemberFilteredSuppliers({params}) {
                    ID
                    BusinessName
                    FirstName
                    Surname
                    BusinessAddress {
                        FullAddress
                    }
                }
            }`,
        },
    },
    stores: {
        listing: {
            url: `${window.baseURL}graphql`,
            query: `{
                readMembers({params}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            ID
                            BusinessName
                            Phone
                            Email
                            BusinessAddress {
                                ...on ElvantiAddress {
                                    ID
                                    StreetNumber
                                    StreetName
                                    StreetSuffix
                                    Suburb
                                    State
                                    PostalCode
                                    Country
                                }
                            }
                        }
                    }
                }
            }`,
        },
        regionList: {
            url: `${window.baseURL}graphql`,
            query: `{
                readCurrentRegion {
                    States {
                        edges {
                            node {
                                Title
                                Code
                            }
                        }
                    }
                }
            }`,
        },
    },
    report: {
        read: {
            url: `${window.baseURL}reports/`,
        },
    },
    dispatch: {
        dispatchList: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readUnManifestedOrders({params}) {
                    edges {
                        node {
                            ID
                            InternalItemID
                            BusinessName
                            FirstName
                            Surname
                            HasTags
                            ContainItemTypes
                            ShippingMethod
                            Placed
                            PostmenLabelUrl
                            BoxPackerParcelCount
                            TrackingNumber
                            PostmenTrackingInfo
                            Status
                            ShippingStatus
                        }
                    }
                }
            }`,
        },
        submitManifest: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {
                generatePostmenManifest {
                    Manifests {
                        ID
                    }
                    FailedOrders {
                        ID
                    }
                }
            }`,
        },
        packOrder: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {
                packOrder(ID: {ID}) {
                    ID
                    Status
                    ShippingStatus
                }
            }`,
        },
        unpackOrder: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {
                unpackOrder(ID: {ID}) {
                    ID
                    Status
                    ShippingStatus
                }
            }`,
        },
        awaitingPickupOrder: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {
                awaitingPickupOrder(ID: {ID}) {
                    ID
                    Status
                    ShippingStatus
                }
            }`,
        },
        manifestList: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readManifests({params}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            ID
                            InternalItemID
                            ShipperAccountTitle
                            ParcelCount
                            Created
                            FileUrl
                            Printed
                        }
                    }
                }
            }`,
        },
        printManifest: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {
                printManifest(ID: {ID}) {
                    ID
                    InternalItemID
                    ShipperAccountTitle
                    ParcelCount
                    Created
                    FileUrl
                    Printed
                }
            }`,
        },
        unprintManifest: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `mutation {
                unprintManifest(ID: {ID}) {
                    ID
                    InternalItemID
                    ShipperAccountTitle
                    ParcelCount
                    Created
                    FileUrl
                    Printed
                }
            }`,
        },
        dispatchHistory: {
            url: `${window.baseURL}graphql-enterprise`,
            query: `{
                readCartOrders({params}) {
                    pageInfo {
                        totalCount
                    }
                    edges {
                        node {
                            ID
                            InternalItemID
                            Placed
                            BusinessName
                            FirstName
                            Surname
                            HasTags
                            ContainItemTypes
                            ShippingMethod
                            PostmenTrackingInfo
                            ShippingStatus
                            BoxPackerParcelCount
                            PlacedOnBehalfBy {
                                ... on Wholesaler {
                                  ID
                                }
                                ... on Reseller {
                                  ID
                                }
                              }
                        }
                    }
                }
            }`,
        },
    },
    stripe: {
        uploadImage: {
            url: `${window.baseURL}api/app/connect/uploadFile`,
        },
        payoutLogs: {
            url: `${window.baseURL}graphql`,
            query: `query readStripeLogs($PayoutReference: String , $StartingAfter: String) {
                readStripeLogs(PayoutReference: $PayoutReference , StartingAfter: $StartingAfter) {
                    edges {
                        node {
                            Date
                            Type
                            Description
                            Amount
                            Reference
                        }
                    }
                }
            }`,
        },
    },

    payfast: {
        payoutLogs: {
            url: `${window.baseURL}graphql`,
            query: `query readPayFastLogs{
                readPayFastLogs {
                    edges {
                        node {
                            response
                        }
                    }
                }
            }`,
        },
    },
};
